import { render } from "./OrdersComponent.vue?vue&type=template&id=a46b5ad8&scoped=true"
import script from "./OrdersComponent.vue?vue&type=script&lang=js"
export * from "./OrdersComponent.vue?vue&type=script&lang=js"

import "./OrdersComponent.vue?vue&type=style&index=0&id=a46b5ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a46b5ad8"]])

export default __exports__